import script from "./DownloadSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadSection.vue?vue&type=script&setup=true&lang=js"

import "./DownloadSection.vue?vue&type=style&index=0&id=be9b8bca&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be9b8bca"]])

export default __exports__